import { Box, Toolbar } from '@mui/material'
import { useContext } from 'react'

import { AppSettingsContext } from '../../Contexts'
import { EventsButton, JsonButton } from '../Components'
import EntityListHeader from './List'

const EntityToolbar: React.FC = () => {
  const { developerMode } = useContext(AppSettingsContext)
  return (
    <Toolbar>
      <Box alignItems="center" display="flex" flexDirection="row" flexGrow={1} justifyContent="space-between">
        <Box display="flex">
          <Box margin={0.5}>
            <EventsButton />
          </Box>
          <Box display={developerMode ? 'flex' : 'none'} margin={0.5}>
            <JsonButton />
          </Box>
        </Box>
      </Box>
    </Toolbar>
  )
}

export { EntityListHeader, EntityToolbar }
